import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CampusFacilities = ({ facilities }) => {
  return (
    <div className="space-y-4 md:space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6">
        {facilities?.highlights?.map((facility, index) => (
          <div
            key={index}
            className="bg-card rounded-lg border border-border overflow-hidden hover:shadow-warm-md transition-smooth"
          >
            <div className="relative h-40 md:h-48 lg:h-56 overflow-hidden">
              <Image
                src={facility?.image}
                alt={facility?.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2 md:mb-3">
                <Icon name={facility?.icon} size={20} color="var(--color-primary)" />
                <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
                  {facility?.name}
                </h4>
              </div>
              <p className="text-sm md:text-base text-muted-foreground font-caption line-clamp-2">
                {facility?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-5 flex items-center gap-2">
          <Icon name="Building2" size={24} color="var(--color-primary)" />
          Campus Amenities
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {facilities?.amenities?.map((amenity, index) => (
            <div key={index} className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={amenity?.icon} size={20} color="var(--color-primary)" />
              </div>
              <span className="text-sm md:text-base text-foreground font-caption font-medium">
                {amenity?.name}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-5 flex items-center gap-2">
          <Icon name="MapPin" size={24} color="var(--color-primary)" />
          Location & Accessibility
        </h3>
        <div className="aspect-video w-full rounded-lg overflow-hidden mb-4 md:mb-5">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title={facilities?.location?.name}
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${facilities?.location?.lat},${facilities?.location?.lng}&z=14&output=embed`}
            className="border-0"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {facilities?.location?.nearby?.map((place, index) => (
            <div key={index} className="flex items-center gap-3">
              <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm md:text-base text-muted-foreground font-caption">
                {place}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CampusFacilities;